/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-08-22 17:30:42
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-07 11:39:54
 * @FilePath: /vue_huaqiang/src/utils/uploadALOss.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getOssAllUpload } from "@/api/upload";
import { Message } from "element-ui";
import OSS from 'ali-oss'

// 阿里云OSS
const client =  async() => {
  // const res = await this.$api.common.system('getOssStsToken')
  const res: any = await getOssAllUpload({ bizType: 'xlsx' })
  if (res) {
    const config = res
    const oss_client = new OSS({
      // region: config.region,
      region: 'oss-cn-hangzhou',
      accessKeyId: config.accessKeyId,
      accessKeySecret: config.accessKeySecret,
      bucket: config.bucketName,
      secure: true,
      // 'hq-packing-list'
      // config.bucketName
      stsToken: config.securityToken,
    })
    return oss_client
  }
}


export const uploadFiles = async(fileClaim:any) => {
  console.log('开始utils之中的upload函数了，这是传过来的fileClaim>>>',fileClaim)
  if (!fileClaim.name) {
    Message.error({
      message: "请选择文件",
      duration: 2000
    });
    return;
  }
  // if (fileList.length > 1) {
  //   Message.error({
  //     message: "单次只能上传一个文件",
  //     duration: 2000
  //   });
  //   return;
  // }
  const file = fileClaim;
  const name = `/remittanceAdvice/${file.name}_${new Date().getTime()}`
  const oss_client = await client()
  const result = await oss_client.put(name, file)
  // console.log('返回的result',result)
  return result
};

// 从OSS删除文件
export const deleteFiles = async(fileName:any) => {
  if (!fileName) {
    Message.error({
      message: "请选择文件",
      duration: 2000
    });
    return;
  }
  const oss_client = await client()
  const result = await oss_client.delete(fileName);
  console.log('删除的结果',result)
  
  return result
};
// 下载文件
export const downloadFiles = async(fileName:any,uploadFileName: string) => {
  if (!fileName) {
    Message.error({
      message: "获取不到文件名！",
      duration: 2000
    });
    return;
  }
  const response = {
    'content-disposition': `attachment; filename=${encodeURIComponent(uploadFileName)}`
  }
  const oss_client = await client()
  const url = oss_client.signatureUrl(fileName, { response });
  console.log('返回的url',url)
  
  return url
};